module.exports = __webpack_public_path__ + "img/bags.55c25af0.svg";